import Config from "../Config";
import type { PageSeoProps } from "../types/components/PageSeoProps";

const permanentStructuredData = Config.meta.structuredData;

const isEmptyObject = (value) =>
	value && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0;

export const PageSeo = ({ title, description, keywords, canonical, image, structuredData }: PageSeoProps) => {
	const structuredDataArray = Array.isArray(structuredData) ? structuredData : structuredData ? [structuredData] : [];
	const structuredDataOutput = [...permanentStructuredData, ...structuredDataArray].filter(
		(data) => data && !isEmptyObject(data),
	);

	return (
		<>
			{/* Meta tags - React 19 hoists these to <head> */}
			{title && <title>{Config.title(title)}</title>}

			{description && (
				<>
					<meta name="description" content={description} />
					<meta property="og:description" content={description} />
				</>
			)}

			{title && <meta property="og:title" content={title} />}

			{keywords && <meta name="keywords" content={keywords} />}

			{image && <meta property="og:image" content={image.replace(".local", ".co.uk")} />}

			{canonical && <link rel="canonical" href={canonical} />}

			{structuredDataOutput.map((data, index) => (
				<script
					key={index}
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
				/>
			))}
		</>
	);
};

export default PageSeo;
